import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export default class FeatureScroll {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
  }

  setVars() {
    this.bg = this.el.querySelector('[data-bg]')
  }

  init() {
    this.handleSectionScroll()
  }

  handleSectionScroll() {
    gsap.fromTo(this.bg, { y: -80 }, {
      scrollTrigger: {
        trigger: this.el,
        scrub: 0.08,
      },
      y: 80,
      ease: 'none',
    })
  }
}
